import { render, staticRenderFns } from "./TestUserNotificationPhoneNumberNotification.vue?vue&type=template&id=5b0b4f8b&scoped=true&"
import script from "./TestUserNotificationPhoneNumberNotification.vue?vue&type=script&lang=js&"
export * from "./TestUserNotificationPhoneNumberNotification.vue?vue&type=script&lang=js&"
import style0 from "./TestUserNotificationPhoneNumberNotification.vue?vue&type=style&index=0&id=5b0b4f8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b4f8b",
  null
  
)

export default component.exports